import { Heatmap } from "./component";
import { HeatmapLegend } from "./HeatmapLegend";
export { Heatmap, HeatmapLegend };



// WEBPACK FOOTER //
// ./client/modules/core/Chart/Heatmap/index.tsx